module.exports = __webpack_public_path__ + "img/icon_UGAToday.dc3a62d2.png";